module.exports = __webpack_public_path__ + "img/appleton.d422aeb5.png";